export function JsCodeIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M14.961 5.275a1 1 0 00-1.923-.55l-4 14a1 1 0 101.923.55l4-14zM4 8a3 3 0 013-3 1 1 0 010 2 1 1 0 00-1 1v1.172a3 3 0 01-.879 2.12L4.414 12l.707.707A3 3 0 016 14.828V16a1 1 0 001 1 1 1 0 110 2 3 3 0 01-3-3v-1.172a1 1 0 00-.293-.707l-1.414-1.414a1 1 0 010-1.414l1.414-1.414A1 1 0 004 9.172V8zM17 5a3 3 0 013 3v1.172a1 1 0 00.293.707l1.414 1.414a1 1 0 010 1.414l-1.414 1.414a1 1 0 00-.293.707V16a3 3 0 01-3 3 1 1 0 110-2 1 1 0 001-1v-1.172a3 3 0 01.879-2.12l.707-.708-.707-.707A3 3 0 0118 9.172V8a1 1 0 00-1-1 1 1 0 110-2z"
      ></path>
    </svg>
  );
}
